/*-----------------------------------------------------------------
- Products
-----------------------------------------------------------------*/
export default {
    titles: {
        list    : 'فروشگاه',
        single  : '{0}',
        category: 'محصولات - دسته‌بندی: {0}',
        tag     : 'محصولات - برچسب: {0}',
    },

    specs: {
        title: 'مشخصات',
    },

    sections: {
        intro   : 'معرفی محصول',
        specs   : 'مشخصات محصول',
        rating  : 'امتیاز محصول',
        comments: 'دیدگاه کاربران',
    },

    comments: {
        form  : 'دیدگاهتان را بنویسید',
        list  : 'دیدگاه کاربران',
        button: 'نوشتن دیدگاه',
    },

    similar_posts: 'محصولات مشابه',
    see_more     : 'مشاهده بیشتر',
    share        : 'اشتراک‌گذاری',
    empty        : 'نتیجه‌ای یافت نشد',
};
